import { MarkerClusterer } from '@googlemaps/markerclusterer';

export function updateMarkerAndCluster(
  map: google.maps.Map | null,
  selectedCategories: string[],
  category: string,
  markerArray,
  clusterer: MarkerClusterer,
) {
  clusterer.clearMarkers();
  const isCategorySelected = selectedCategories.includes(category);
  markerArray.forEach((marker) => (marker.map = isCategorySelected ? map : null));
  clusterer.addMarkers(markerArray);
  if (!isCategorySelected) {
    clusterer.clearMarkers();
  }
}
